import React from "react";

import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  arrayMove,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import MediaComponent from "../MediaComponent.js";
import PollComponent from "../PollComponent.js";
import TextComponent from "../TextComponent.js";
import SpeechAssessmentComponent from "../SpeechAssessmentComponent.js";
import SubmitFeedComponent from "../SubmitFeedComponent.js";
import DNDKitSortableList from "./DNDKitSortableList";
import InstagramWrapper from "../socialglass/post_components/InstagramWrapper.js";
import TikTokWrapper from "../socialglass/post_components/TikTokWrapper.js";
import TwitterWrapper from "../socialglass/post_components/TwitterWrapper.js";
import YoutubeWrapper from "../socialglass/post_components/YoutubeWrapper.js";

function RightTab({
  selectedAssets,
  setSelectedAssets,
  activeTab,
  setActiveTab,
  createdFeedID,
  token,
  isLoading,
  handleFinalize,
  setChoosenPosts,
}) {
  // Asset Content Renderer
  const renderAssetContent = (asset) => {
    // if (asset.platform !== undefined ) {
    //   console.log("Asset detail: ", asset);
    //   console.log("Asset URL: ", asset.url);
    //   switch (asset.platform) {
    //     case "instagram":
    //       return <InstagramWrapper url={asset.url} />;

    //     case "tiktok":
    //       return <TikTokWrapper platform="tiktok" url={asset.url} />;

    //     case "twitter":
    //       // console.log("Twitter URL: ", asset.url);
    //       // // Replace x.com with twitter.com for Twitter URLs
    //       // const twitterUrl = asset.url.replace("x.com", "twitter.com");
    //       return <TwitterWrapper url={asset.url} />;

    //     case "youtube":
    //       return <YoutubeWrapper url={asset.url} />;

    //     default:
    //       return <p>Unsupported platform</p>;
    //   }
    // }

    try {
      const content = JSON.parse(asset.AssetContent);
      console.log("Asset content:", content);
      switch (content.assetType) {
        case "poll":
          if (content.pollType === "survey") {
            return (
              <FeedPollSurvey
                surveyPolls={content.selections}
                assetContent={content}
                userID={() => {}}
                feedID={createdFeedID}
                activeAssetId={asset.AssetID}
                token={token}
                setToken={() => {}} // Placeholder since we're in preview mode
              />
            );
          } else if (content.pollType === "submit_button") {
            return (
              <SubmitFeedComponent
                assetContent={content}
                activeAssetId={asset.AssetID}
                feedID={createdFeedID}
                token={token}
                setToken={() => {}} // Placeholder since we're in preview mode
              />
            );
          }
          return (
            <div className="rounded-lg bg-gray-50 p-4">
              <PollComponent
                assetContent={content}
                token={token}
                activeAssetId={asset.AssetID}
                feedID={createdFeedID}
                setToken={() => {}} // Placeholder since we're in preview mode
              />
            </div>
          );
        case "text":
          return (
            <div className="prose prose-sm max-w-none">
              <TextComponent assetContent={content} />
            </div>
          );
        case "media":
          return (
            <div className="relative aspect-video">
              <MediaComponent mediaLink={content.mediaContent} />
            </div>
          );
        case "SpeechAsset":
          return (
            <div className="relative aspect-video">
              <SpeechAssessmentComponent
                mediaLink={content.mediaContent}
                activeAssetId={asset.AssetID}
                feedID={createdFeedID}
                caption={asset.Caption}
                token={token}
              />
            </div>
          );
        default:
          return <p>Unsupported asset type: {content.assetType}</p>;
      }
    } catch (error) {
      console.error("Error rendering asset content:", error);
      return <p>Error displaying content</p>;
    }
  };

  const handleDragEnd = (event) => {
    const { active, over } = event;

    if (active.id === over.id) {
      return;
    }
    const oldIndex = selectedAssets.findIndex(
      (asset) => asset.AssetID === active.id,
    );
    const newIndex = selectedAssets.findIndex(
      (asset) => asset.AssetID === over.id,
    );

    if (oldIndex !== newIndex) {
      const updatedAssets = arrayMove(selectedAssets, oldIndex, newIndex);
      console.log("Updated assets:", updatedAssets);

      setSelectedAssets(updatedAssets);
    }
  };

  const handleRemoveAsset = (assetID) => {
    setSelectedAssets((prev) =>
      prev.filter((asset) => asset.AssetID !== assetID),
    );
  };

  return (
    <div className="flex flex-1 flex-col overflow-hidden">
      <div className="border-b border-gray-200 bg-white p-6 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex space-x-4">
            <button
              onClick={() => setActiveTab("list")}
              className={`rounded-md px-4 py-2 transition-colors ${
                activeTab === "list"
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              Selected Assets ({selectedAssets.length})
            </button>
            <button
              onClick={() => setActiveTab("preview")}
              className={`rounded-md px-4 py-2 transition-colors ${
                activeTab === "preview"
                  ? "bg-blue-50 text-blue-600"
                  : "text-gray-600 hover:text-gray-800"
              }`}
            >
              Feed Preview
            </button>
          </div>
          <button
            onClick={handleFinalize}
            disabled={isLoading || !selectedAssets.length}
            className={`rounded-md px-4 py-2 text-white transition-colors ${
              isLoading || !selectedAssets.length
                ? "cursor-not-allowed bg-gray-400"
                : "bg-blue-500 hover:bg-blue-600"
            }`}
          >
            {isLoading ? "Creating Feed..." : "Create Feed"}
          </button>
        </div>
      </div>

      <div className="flex-1 overflow-y-auto">
        {activeTab === "list" ? (
          <DndContext
            collisionDetection={closestCenter}
            onDragEnd={handleDragEnd}
          >
            <SortableContext
              items={selectedAssets.map((asset) => asset.AssetID)}
              strategy={verticalListSortingStrategy}
            >
              <div className="p-6">
                {selectedAssets.map((asset, index) => (
                  <DNDKitSortableList
                    id={asset.AssetID}
                    key={asset.AssetID}
                    index={index}
                    handleRemoveAsset={handleRemoveAsset}
                  >
                    {asset}
                  </DNDKitSortableList>
                ))}
              </div>
            </SortableContext>
          </DndContext>
        ) : (
          <div className="space-y-8 p-6">
            {selectedAssets.map((asset, index) => (
              <div
                key={asset.AssetID}
                className="overflow-hidden rounded-lg border border-gray-200 bg-white"
              >
                <div className="p-4">
                  <div className="mb-4 flex items-center">
                    <div className="flex-shrink-0">
                      {asset.BrandProfilePicture ? (
                        <img
                          src={`https://genz-staging.feeltiptop.com/${asset.BrandProfilePicture}`}
                          alt={asset.BrandName}
                          className="h-12 w-12 rounded-full"
                        />
                      ) : (
                        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-gray-100">
                          <span className="text-lg font-medium text-gray-500">
                            {asset.BrandName?.[0] || "B"}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mb-4">
                    <h3 className="mb-2 font-medium text-gray-900">
                      {asset.AssetName}
                    </h3>
                    {asset.Caption && (
                      <p className="text-gray-600">{asset.Caption}</p>
                    )}
                  </div>

                  <div className="overflow-hidden rounded-lg border">
                    {renderAssetContent(asset)}
                  </div>

                  {asset.OpenLink && (
                    <div className="mt-4 flex items-center">
                      <a
                        href={asset.OpenLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center text-blue-600 hover:text-blue-800"
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(asset.OpenLink, "_blank");
                        }}
                      >
                        <span className="mr-2">Open Link</span>
                        <svg
                          className="h-4 w-4"
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                          />
                        </svg>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default RightTab;
